// Create and Edit payloads are intentionally identical. The edit endpoint uses
// PATCH with the id in the URL (not in the body), so no id field is needed here.
// Kept as separate functions for consistency with the QuickLinks adapter pattern.
function buildKeyShoutFormData(
	data: Partial<KeyShout>,
	imageFile: File | null
): FormData {
	const formData = new FormData();
	formData.append("heading", data.heading ?? "");
	formData.append("content", data.content ?? "");
	formData.append("button_link", data.buttonLink ?? "");
	formData.append("webview", String(data.webview ?? false));

	if (imageFile) {
		formData.append("image", imageFile);
	}

	return formData;
}

export const adaptCreateKeyShoutPayload = (
	data: Partial<KeyShout>,
	imageFile: File | null
): FormData => {
	return buildKeyShoutFormData(data, imageFile);
};

export const adaptEditKeyShoutPayload = (
	data: Partial<KeyShout>,
	imageFile: File | null
): FormData => {
	return buildKeyShoutFormData(data, imageFile);
};
